<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :actionButtons="[]"
    :title="$t('menu.dataAnalysis')"
    :onFetchData="onFetchData"
    ref="sourcePage"
    resource="product_design_analyses"
  >
    <template v-slot:action>
      <el-button type="primary" @click="() => exportClick(selection)">导出</el-button>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { columnsExtend, filterColumnsExtend } from '../admin_grapes/product_designs.js';
import { filterColumnsExtend as userFilterColumnsExtend } from '../admin_grapes/users.js';
import _ from 'lodash';

@Component
export default class ProductDesignUserEffectAnalyses extends Vue {
  @Prop(String) type;

  async onFetchData() {
    const data = await this.$request.get('product_designs/user_effect_analyses', { params: { ...this.$route.query } });
    return {
      data
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    let [role] = userFilterColumnsExtend(['role_eq']);
    role.renderCell.props.options = _.map(['designer', 'salesman', 'sales_director', 'cheif_pattern_making_officier', 'pattern_maker', 'craftsman', 'sewer', 'valuer', 'supplier_boss', 'supplier'], (role) => ({
      label: this.$t(`user.roles.${role}`),
      value: role
    }))

    const array = [
      {
        prop: 'date_range',
        label: '时间范围',
        renderCell: {
          component: 'el-date-picker',
          props: {
            type: 'daterange',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {
              shortcuts: [
                {
                  text: '今天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '昨天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24);
                    end.setTime(end.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '近7天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '近15天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                    picker.$emit('pick', [start, end]);
                  }
                },
                {
                  text: '近30天',
                  onClick: (picker) => {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                  }
                }
              ]
            }
          }
        }
      },
      'pattern_factory_eq',
      'company_id_eq',
      { ...role },
      'state_in'
    ].filter(Boolean)

    return filterColumnsExtend(array);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns() {
    const array = [
      {
        prop: 'company',
        label: '供应商'
      },
      {
        prop: 'role',
        label: '角色'
      },
      {
        prop: 'operator',
        label: '姓名'
      },
      {
        prop: 'total_confirm_product_designs_count',
        label: '确认制单/拒绝总款数',
        width: 100
      },
      {
        prop: 'avg_confirm_time_consuming',
        label: '确认制单/拒绝平均时效(分钟)',
        width: 100,
        formatter: (row) => row.avg_confirm_time_consuming ? row.avg_confirm_time_consuming.toFixed(2) : null
      },
      {
        prop: 'total_purchaser_product_designs_count',
        label: '面、辅料采购总款数',
        width: 100,
      },
      {
        prop: 'avg_purchaser_time_consuming',
        label: '面、辅料采购平均时效(分钟)',
        width: 100,
        formatter: (row) => row.avg_purchaser_time_consuming ? row.avg_purchaser_time_consuming.toFixed(2) : null
      },
      {
        prop: 'total_make_plate_product_designs_count',
        label: '纸样确认/拒绝总款数',
        width: 100,
      },
      {
        prop: 'avg_make_plate_time_consuming',
        label: '纸样确认/拒绝平均时效(分钟)',
        width: 100,
        formatter: (row) => row.avg_make_plate_time_consuming ? row.avg_make_plate_time_consuming.toFixed(2) : null
      },
      {
        prop: 'total_craft_product_designs_count',
        label: '工艺确认/拒绝总款数',
        width: 100,
      },
      {
        prop: 'avg_craft_time_consuming',
        label: '工艺确认/拒绝平均时效(分钟)',
        width: 100,
        formatter: (row) => row.avg_craft_time_consuming ? row.avg_craft_time_consuming.toFixed(2) : null
      },
      {
        prop: 'total_sew_product_designs_count',
        label: '车缝确认/拒绝总款数',
        width: 100,
      },
      {
        prop: 'avg_sew_time_consuming',
        label: '车缝确认/拒绝平均时效(分钟)',
        width: 100,
        formatter: (row) => row.avg_sew_time_consuming ? row.avg_sew_time_consuming.toFixed(2) : null
      },
      {
        prop: 'total_review_plate_product_designs_count',
        label: '审版确认/拒绝总款数',
        width: 100,
      },
      {
        prop: 'avg_review_plate_time_consuming',
        label: '审版平均时效(分钟)',
        width: 100,
        formatter: (row) => row.avg_review_plate_time_consuming ? row.avg_review_plate_time_consuming.toFixed(2) : null
      },
      {
        prop: 'total_audit_quantity_product_designs_count',
        label: '成本核价总款数',
        width: 100,
      },
      {
        prop: 'avg_audit_quantity_time_consuming',
        label: '成本核价平均时效(分钟)',
        width: 100,
        formatter: (row) => row.avg_audit_quantity_time_consuming ? row.avg_audit_quantity_time_consuming.toFixed(2) : null
      },
    ].filter(Boolean)

    return columnsExtend(array);
  }


  async exportClick() {
    await this.$request.get('/product_designs/export_user_effect_analyses', { ...this.$route.query });
    this.$message.success('文件正在导出，导出成功后将会发送到邮箱');
  }
}

export const route = [
  {
    path: '/product_design_user_effect_analyses',
    name: 'product_design_user_effect_analyses.index',
    component: ProductDesignUserEffectAnalyses,
    props: {
      type: 'index',
    }
  },
]
</script>
